"use strict";

import jQuery from 'jquery';

/**
 * Control um Karte zum aktuellen Standort mittels Browser-Geolocation-API zu
 * bewegen.
 *
 * @class
 * @extends gc.gis.control.GCAbstractMapControl
 * @memberof gc.gis.control
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen (siehe {@link gc.gis.control.GCAbstractMapControl})
 */
gc.gis.control.GCMapGeolocator = function( options )
{
	gc.gis.control.GCAbstractMapControl.call( this, options );

	this.__element_label = undefined;
	this.__element_button = undefined;
};
gc.gis.control.GCMapGeolocator.prototype = Object.create( gc.gis.control.GCAbstractMapControl.prototype );

/**
 * @inheritdoc
 */
gc.gis.control.GCMapGeolocator.prototype.init = function()
{
	this._render();
};

/**
 * Rendert das Control.
 *
 * @protected
 * @return {jQuery} Container-Element
 */
gc.gis.control.GCMapGeolocator.prototype._render = function()
{
	var self = this;

	if( !this._element )
	{
		this.__element_label = jQuery('<span>', {
			text: 'Aktuellen Standort verwenden'
		});

		this.__element_button = jQuery('<button>', {
			'class': 'gc-map-control-button',
			html: this.__element_label,
			title: 'Aktuellen Standort verwenden'
		});
		this.__element_button.prepend( jQuery('<span>', {
			'class': 'gc-icon ms ms-streetview'
		}) );
		this.__element_button.on('click', function( evt ) {
			try
			{
				self.zoomToPosition();
			}
			catch( err )
			{
				gc.gis.iface.log.error(self, err);
			}
			jQuery(this).blur();
		});

		this._element = jQuery('<div>', {
			'class': 'gc-map-control gc-map-control-geolocator',
			html: this.__element_button
		});
		gc.gis.iface.ui.tooltip(this.__element_button, {
			placement: 'auto top'
		});
	}
	return this._element;
};

/**
 * Fragt den aktuellen Standord des Browsers per Geolocation-API ab und bewegt
 * die Karte dort hin.
 *
 * @public
 * @throws gc.gis.error.GCUnsupportedActionError wenn der Browser keine
 *   Geolocation-API unterstützt
 * @throws gc.gis.error.GCError wenn bei der Positionsbestimmung ein Fehler
 *   auftritt
 */
gc.gis.control.GCMapGeolocator.prototype.zoomToPosition = function()
{
	var self = this;

	if( 'geolocation' in navigator )
	{
		var success = function( position )
		{
			var lon = position.coords.longitude;
			var lat = position.coords.latitude;

			self._map.panTo( [lon, lat], "EPSG:4326");
			self._map.showMarker('Aktueller Standort (Genauigkeit ca. ' + position.coords.accuracy + 'm)', [lon, lat], {
				projection: "EPSG:4326"
			});
		};

		var failure = function(error)
		{
			//throw new gc.gis.error.GCError('Fehler beim bestimmen der aktuellen Position via Geolocation-API.');
			// Exception wird im Kontext der GeoLocation-API nicht durchgereicht
			gc.gis.iface.log.error(self, 'Fehler beim bestimmen der aktuellen Position via Geolocation-API'
			 	+ ' (Fehler: "' + error.message + '").');
		};

		navigator.geolocation.getCurrentPosition(success, failure);
	}
	else
	{
		throw new gc.gis.error.GCUnsupportedActionError('Geolocation-API ist in diesem Browser nicht verfügbar.');
	}

};

